import { HugeiconsIcon } from "@hugeicons/react";
import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import {
  LabelPosition,
  Switch,
  SwitchSize
} from "shared/components/forms/Switch";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";

const INFO =
  "BoomScreen invite and Applicant invite. These leads are created when a screening or co-applicant invite is sent, usually after the person already came in through another channel. Turn this on to include them.";

export const BoomScreenSourcesToggle = ({
  checked,
  onChange
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
}) => (
  <div className="flex items-center gap-2">
    <Switch
      checked={checked}
      onChange={onChange}
      size={SwitchSize.SM}
      position={LabelPosition.Left}
      label={
        <span className="text-sm font-medium text-content-700 whitespace-nowrap">
          Show BoomScreen sources
        </span>
      }
    />
    <Tooltip placement="bottom-end">
      <TooltipTrigger
        aria-label="About BoomScreen sources"
        className="flex shrink-0 rounded-full text-content-300 hover:text-content-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500"
      >
        <HugeiconsIcon icon={InformationCircleIcon} size={16} />
      </TooltipTrigger>
      <TooltipContent className="z-[1100] max-w-[364px] rounded-lg p-4 text-sm font-medium text-white">
        {INFO}
      </TooltipContent>
    </Tooltip>
  </div>
);
